import { tiers, topicStats } from "@/mocks/home";

const topPlayers = [
  { rank: 1, name: "瓜界天花板", score: "98,420", title: "连答 50 关零失误", hue: "bg-primary-500" },
  { rank: 2, name: "嗑学家小苏", score: "96,871", title: "古装考古卷三连满分", hue: "bg-accent-400" },
  { rank: 3, name: "翻山老番薯", score: "94,033", title: "本周挑战参与 41 次", hue: "bg-secondary-300" },
];

export default function Levels() {
  return (
    <section id="rank" className="w-full bg-background-50 py-14 md:py-20">
      <div className="shell">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="sec-eyebrow">Rank up the ladder</p>
            <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
              从瓜田路人，一路
              <span className="text-primary-600">卷成瓜王</span>
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-foreground-600">
            每答对一题都计入成长值，段位可升级更会掉段，压力与快乐并存。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-6 lg:grid-cols-3">
          {/* ladder */}
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-2">
            {tiers.map((t, idx) => (
              <div
                key={t.name}
                className="relative flex flex-col rounded-lg border p-5"
              >
                <span
                  className="absolute -top-0 right-4 -translate-y-1/2 rounded-full bg-foreground-900 px-2 py-0.5 font-display text-[11px] font-bold tracking-wider text-background-50"
                >
                  Lv.{idx + 1}
                </span>
                <div className="flex items-center gap-3">
                  <span
                    className={
                      "grid h-11 w-11 shrink-0 items-center justify-center rounded-lg text-xl " +
                      (idx === tiers.length - 1 ? "bg-primary-500 text-background-50" : "bg-background-100 text-primary-600")
                    }
                  >
                    <i className={t.icon} aria-hidden="true" />
                  </span>
                  <div>
                    <h3 className="font-heading text-lg font-black text-foreground-950">{t.name}</h3>
                    <p className="font-display text-xs tracking-wide text-foreground-400">{t.range}</p>
                  </div>
                </div>
                <p className="mt-3 text-[13px] leading-relaxed text-foreground-600">{t.desc}</p>

                {/* next goal bar */}
                <div className="mt-auto pt-4">
                  <div className="mb-1.5 flex items-center justify-between text-[11px] text-foreground-400">
                    <span>{idx === tiers.length - 1 ? "本段最高" : "晋升到下一段还需"}</span>
                    <span className="font-medium text-primary-600">
                      {idx === tiers.length - 1 ? "100%" : "下一档 200 分"}
                    </span>
                  </div>
                  <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                    <div
                      className={
                        "h-full rounded-full " + (idx === tiers.length - 1 ? "bg-primary-500" : "bg-accent-400")
                      }
                      style={{ width: idx === tiers.length - 1 ? "100%" : `${45 + idx * 12}%` }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* right column: distribution + top players */}
          <div className="flex flex-col gap-6">
            <div className="rounded-lg border border-background-200 bg-background-100 p-5">
              <div className="flex items-center justify-between">
                <h4 className="font-heading text-base font-black text-foreground-950">出题分布</h4>
                <span className="chip">
                  <i className="ri-bar-chart-box-line mr-1 text-sm text-primary-500" aria-hidden="true" />
                  本周
                </span>
              </div>
              <ul className="mt-4 space-y-3.5">
                {topicStats.map((t) => (
                  <li key={t.label}>
                    <div className="flex items-center justify-between text-xs">
                      <span className="font-medium text-foreground-700">{t.label}</span>
                      <span className="font-display text-sm font-bold tracking-wide text-primary-600">{t.pct}</span>
                    </div>
                    <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                      <div
                        className="h-full rounded-full bg-gradient-to-r from-primary-400 to-accent-400"
                        style={{ width: t.pct }}
                      />
                    </div>
                    <p className="mt-1 text-[11px] text-foreground-400">{t.hint}</p>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-lg border border-primary-200 bg-primary-100/50 p-5">
              <h4 className="font-heading text-base font-black text-foreground-950">本季最热瓜王</h4>
              <ul className="mt-4 space-y-3">
                {topPlayers.map((p) => (
                  <li key={p.rank} className="flex items-center gap-3">
                    <span className="font-display w-7 text-center text-xl font-bold tracking-wide text-primary-500">
                      {p.rank}
                    </span>
                    <span className={"grid h-9 w-9 shrink-0 items-center justify-center rounded-full text-sm font-bold text-foreground-950 " + p.hue}>
                      {p.name.charAt(0)}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="truncate text-sm font-bold text-foreground-950">{p.name}</p>
                      <p className="truncate text-[11px] text-foreground-500">{p.title}</p>
                    </div>
                    <span className="font-display text-sm font-bold tracking-wide text-foreground-700">
                      {p.score}
                    </span>
                  </li>
                ))}
              </ul>
              <button
                type="button"
                className="mt-4 w-full rounded-md border border-primary-300 bg-background-50 py-2 text-sm font-bold text-primary-700 transition-colors hover:bg-primary-500 hover:text-background-50 cursor-pointer"
                onClick={() => undefined}
              >
                我也要上榜
                <i className="ri-arrow-right-up-line ml-1" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}